import { AdminContainer } from '@/components/containers';
import { ChangePasswordForm } from '@/components/forms/change-password.form.component';
import { cn } from '@/lib/utils';

export default function Profile() {
  return (
    <AdminContainer className={cn('flex flex-col')} title="Profile">
      <ChangePasswordForm />
    </AdminContainer>
  );
}
